<router-outlet>

</router-outlet>

<ngx-spinner [name]="loadingSpinner" bdColor="#2b2b2b" size="large" color="#c2185b" type="square-jelly-box1"
    [fullScreen]="true">
    <img src="../assets/loading.gif" alt="" style="width: 100%">
</ngx-spinner>